import { render } from "./buttons.vue?vue&type=template&id=39087537"
import script from "./buttons.vue?vue&type=script&lang=js"
export * from "./buttons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__